import React from 'react';
import { SkeletonItem, InternalGrid } from '@paygreen/paygreen-ui';
import { IsMobile, IsDesktop } from '../../../utils/tools';

export const ProductCardGrid = (props) => (
    <InternalGrid
        displayType="grid"
        gridTemplateColumns={IsMobile() ? '1fr' : '1fr 1fr 1fr'}
        gridTemplateRows="1fr 1fr"
        gridGap={IsDesktop() ? 'sm' : 'lg'}
        justifyItems="stretch"
        alignItems="stretch"
    >
        {props.children}
    </InternalGrid>
);

const ProductCardSkeletons = () => {
    const skeletonProps = {
        blockWidth: 'auto',
        blockHeight: 'tiny',
        radiusSize: 'sm',
        colorWab: 'grey10',
    };

    return (
        <ProductCardGrid>
            <SkeletonItem {...skeletonProps} />

            <SkeletonItem {...skeletonProps} />

            <SkeletonItem {...skeletonProps} />

            <SkeletonItem {...skeletonProps} />

            <SkeletonItem {...skeletonProps} />

            <SkeletonItem {...skeletonProps} />
        </ProductCardGrid>
    );
};

export default ProductCardSkeletons;
